import React from "react";
import ReactDOM from "react-dom/client";
import JobSearch from "./JobSearch";

const jobListRoot = document.getElementById("job-list");

if (jobListRoot) {
    const root = ReactDOM.createRoot(jobListRoot);
    root.render(<JobSearch />);
}
